var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as profileAction from '../actions/profile.action';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { ProfileService } from '../../profile.service';
var ProfileEffect = /** @class */ (function () {
    function ProfileEffect(actions, profileService, store) {
        var _this = this;
        this.actions = actions;
        this.profileService = profileService;
        this.store = store;
        this.getPopup = this.actions.ofType(profileAction.GET_POPUP)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.profileService.getPopup(body)
                .map(function (res) { return new profileAction.GetPopupSuccess(res); })
                .catch(function (error) { return of(new profileAction.GetPopupError(error)); });
        }));
        this.updateProfileDetail = this.actions.ofType(profileAction.UPDATE_PROFILE_DETAILS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.profileService.updateProfileDetails(body)
                .map(function (res) { return new profileAction.UpdateProfileDetailsSuccess(res); })
                .catch(function (error) { return of(new profileAction.UpdateProfileDetailsError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProfileEffect.prototype, "getPopup", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProfileEffect.prototype, "updateProfileDetail", void 0);
    return ProfileEffect;
}());
export { ProfileEffect };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/store/effects/profile.effect.ts.pre-build-optimizer.js